/**
 * Corporate sub-view identifiers.
 *
 * Edverum branches on TWO orthogonal axes:
 *   1. Client axis  - EdverumClient enum (deploy-time, per-process)
 *                     Values: stanbridge | corporate
 *   2. Role axis    - Vuex User role getters (request-time, per-user)
 *                     Values: admin | student  (this file)
 *
 * The role axis is only meaningful inside the corporate client variant; stanbridge
 * has its own role gating via existing gates and policies. See
 * `useCorporateUserRole.js` for the resolution logic and
 * `docs/domains/client-variants.md` for the broader pattern.
 */
export const CORPORATE_USER_ROLES = Object.freeze({
    ADMIN: 'admin',
    STUDENT: 'student',
});

/**
 * Default sub-view rendered when the user state isn't available (e.g. tests
 * that don't register the User module, or transient pre-hydration windows).
 *
 * We intentionally default to STUDENT - the less-privileged variant - so any
 * missing-data path fails closed and never accidentally exposes the admin
 * surface (Manage Users / Settings / AI course creation) to an unauthenticated
 * or partially-loaded viewer.
 */
export const DEFAULT_CORPORATE_USER_ROLE = CORPORATE_USER_ROLES.STUDENT;
